import {
	useCreateOrUpdateNotificationUserMutation,
	useListNotificationsUsersQuery,
} from '@/features/notifications/notificationsApi';
import { emailSchema } from '@/utils/validation';
import { Autocomplete, Chip, TextField } from '@mui/material';
import React, { useRef, useState } from 'react';
import { ENTER_KEYS } from './data';

const NotificationEmailAutocomplete = ({ type, action, ...props }) => {
	const ref = useRef();

	const [textValue, setTextValue] = useState('');
	const [error, setError] = useState('');

	const { data: emails, ...notificationUsersQuery } = useListNotificationsUsersQuery(type, {
		selectFromResult: ({ data, ...rest }) => {
			const emails =
				data
					?.filter((r) => r.actions?.find((d) => d.action === action)?.active && r.email)
					?.map((r) => r.email) ?? [];
			return {
				...rest,
				data: emails,
			};
		},
	});

	const [addUser, addUserState] = useCreateOrUpdateNotificationUserMutation();

	const handleChange = async (val) => {
		const newArray = Array.from(new Set(val));

		const newValues = await Promise.all(
			newArray.map(async (v) => {
				return emailSchema(false)
					.validate(v)
					.then((r) => {
						console.log('R', r);
						return v;
					})
					.catch((e) => null);
			}),
		).then((r) => r.filter(Boolean));

		const added = newValues.filter((e) => !emails.includes(e));
		const removed = emails.filter((e) => !newValues.includes(e));

		for (const email of added) {
			await addUser({ email, type, actions: [{ action, active: true }] }).unwrap();
		}
		for (const email of removed) {
			await addUser({ email, type, actions: [{ action, active: false }] }).unwrap();
		}
	};

	return (
		<Autocomplete
			multiple
			open={false}
			options={emails}
			value={emails}
			autoComplete={false}
			disabled={addUserState.isLoading || notificationUsersQuery.isLoading}
			onChange={(e, v) => {
				console.log('Handle change', { v });
				handleChange(v);
			}}
			freeSolo
			inputValue={textValue}
			onInputChange={(e, v) => {
				setError('');
				setTextValue(v);
			}}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || ENTER_KEYS.includes(e.key)) {
					e.preventDefault();
					e.defaultMuiPrevented = true;
					emailSchema(false)
						.validate(textValue)
						.catch((e) => {
							setTextValue(textValue);
							setError(e.message);
							return;
						});
					setError('');
					handleChange([...emails, textValue]);
					setTextValue('');
				}
			}}
			renderValue={(value, getItemProps) =>
				value.map((option, index) => {
					const { key, ...itemProps } = getItemProps({
						index,
					});
					return <Chip variant='outlined' label={option} key={key} {...itemProps} />;
				})
			}
			renderInput={(params) => (
				<TextField
					ref={ref}
					{...params}
					placeholder='Enter an email address'
					{...(error && { error: Boolean(error), helperText: error })}
				/>
			)}
			{...(props ?? {})}
		/>
	);
};
export default NotificationEmailAutocomplete;
